import React, { useContext } from 'react'
import { Context } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const withListingPageContext = (mapStateToProps = () => { }) => (Component) => function ({ ...props }) {
  const context = useContext(Context)

  return (
    <Component {...props} {...mapStateToProps(context, props)} />
  )
}

export default withListingPageContext
